import { api } from "./axiosInstance";
import type { Marker, MarkerCategory } from "../types/domain.types";

export interface ListMarkersParams {
  planId: string;
  from?: string;
  to?: string;
}

export async function listMarkersRequest(
  params: ListMarkersParams,
): Promise<Marker[]> {
  const { data } = await api.get<Marker[]>("/markers", { params });
  return data;
}

export interface CreateMarkerInput {
  planId: string;
  qrCode: string;
  category?: MarkerCategory;
  coordX: number;
  coordY: number;
  comment?: string;
}

export interface CreateMarkerResponse {
  id: string;
  createdAt: string;
}

export async function createMarkerRequest(
  input: CreateMarkerInput,
): Promise<CreateMarkerResponse> {
  const { data } = await api.post<CreateMarkerResponse>("/markers", input);
  return data;
}

export interface UpdateMarkerInput {
  comment?: string;
  qrCode?: string;
  category?: MarkerCategory;
  coordX?: number;
  coordY?: number;
}

export async function updateMarkerRequest(
  id: string,
  input: UpdateMarkerInput,
): Promise<{ id: string; qrCode: string; category: MarkerCategory | null; coordX: number; coordY: number; comment: string | null; updatedAt: string }> {
  const { data } = await api.patch(`/markers/${id}`, input);
  return data;
}

export async function deleteMarkerRequest(id: string): Promise<void> {
  await api.delete(`/markers/${id}`);
}
